const navi = window.navigator

type TPermissionName = PermissionName | 'clipboard-read'

export default async function isGranted (permission: TPermissionName): Promise<boolean> {
  const name = permission as PermissionName
  const res = await navi.permissions.query({ name })

  return res.state === 'granted'
}
